export const FETCH_PRICE_BEGIN = 'FETCH_PRICE_BEGIN';
export const FETCH_PRICE_SUCCESS = 'FETCH_PRICE_SUCCESS';
export const FETCH_PRICE_FAILURE = 'FETCH_PRICE_FAILURE';
